/**
 * Validation rules for runner fields.
 */

/**
 * Validates a runner name.
 * Runner names should consist of letters, numbers, spaces, and dashes.
 * @param name The name to validate
 * @returns An error message if invalid, or an empty string if valid.
 */
export function validateRunnerName(name: string): string {
  if (!name) {
    return 'Name is required.';
  }

  const regex = /^[a-zA-Z0-9-]+(?: +[a-zA-Z0-9-]+)*$/;
  if (!regex.test(name)) {
    return 'Letters, numbers, spaces and dashes only e.g., my new server-01';
  }

  return '';
}
